import { fs } from './fs';
const titlepieceDefaults = {
    lineHeight: 'tight',
    fontWeight: 'bold',
    fontStyle: null,
    unit: 'rem',
};
const titlepieceFs = fs('titlepiece');
export const titlepiece = {
    small: (options) => titlepieceFs('small', Object.assign({}, titlepieceDefaults, options)),
    medium: (options) => titlepieceFs('medium', Object.assign({}, titlepieceDefaults, options)),
    large: (options) => titlepieceFs('large', Object.assign({}, titlepieceDefaults, options)),
};
const headlineDefaults = {
    lineHeight: 'tight',
    fontWeight: 'medium',
    fontStyle: null,
    unit: 'rem',
};
const headlineFs = fs('headline');
export const headline = {
    xxxsmall: (options) => headlineFs('xxxsmall', Object.assign({}, headlineDefaults, options)),
    xxsmall: (options) => headlineFs('xxsmall', Object.assign({}, headlineDefaults, options)),
    xsmall: (options) => headlineFs('xsmall', Object.assign({}, headlineDefaults, options)),
    small: (options) => headlineFs('small', Object.assign({}, headlineDefaults, options)),
    medium: (options) => headlineFs('medium', Object.assign({}, headlineDefaults, options)),
    large: (options) => headlineFs('large', Object.assign({}, headlineDefaults, options)),
    xlarge: (options) => headlineFs('xlarge', Object.assign({}, headlineDefaults, options)),
};
const bodyDefaults = {
    lineHeight: 'loose',
    fontWeight: 'regular',
    fontStyle: null,
    unit: 'rem',
};
const bodyFs = fs('body');
export const body = {
    small: (options) => bodyFs('small', Object.assign({}, bodyDefaults, options)),
    medium: (options) => bodyFs('medium', Object.assign({}, bodyDefaults, options)),
};
const textSansDefaults = {
    lineHeight: 'loose',
    fontWeight: 'regular',
    fontStyle: null,
    unit: 'rem',
};
const textSansFs = fs('textSans');
export const textSans = {
    xxsmall: (options) => textSansFs('xxsmall', Object.assign({}, textSansDefaults, options)),
    xsmall: (options) => textSansFs('xsmall', Object.assign({}, textSansDefaults, options)),
    small: (options) => textSansFs('small', Object.assign({}, textSansDefaults, options)),
    medium: (options) => textSansFs('medium', Object.assign({}, textSansDefaults, options)),
    large: (options) => textSansFs('large', Object.assign({}, textSansDefaults, options)),
    xlarge: (options) => textSansFs('xlarge', Object.assign({}, textSansDefaults, options)),
    xxlarge: (options) => textSansFs('xxlarge', Object.assign({}, textSansDefaults, options)),
    xxxlarge: (options) => textSansFs('xxxlarge', Object.assign({}, textSansDefaults, options)),
};
//# sourceMappingURL=api.js.map
